<template>
    <div
        class="file-viewer-chrome tw:flex tw:flex-wrap tw:items-center tw:gap-x-3 tw:gap-y-1 tw:shrink-0 tw:border-b tw:border-gray-200 tw:px-3 tw:py-1.5 tw:bg-blue-50"
        data-test="file-viewer-chrome"
    >
        <div
            v-if="items.length"
            class="file-viewer-context tw:flex tw:min-w-0 tw:flex-wrap tw:items-center tw:gap-x-3 tw:gap-y-1 tw:text-sm tw:text-gray-600"
            data-test="file-viewer-context"
        >
            <template v-for="(item, index) in items" :key="item.key">
                <span v-if="index > 0" class="tw:text-gray-400" aria-hidden="true">|</span>
                <span class="tw:min-w-0 tw:truncate">
                    <span class="tw:font-semibold">{{ item.label }}:</span>
                    {{ item.value }}
                </span>
            </template>
        </div>

        <div
            v-if="$slots.default"
            class="file-viewer-controls tw:flex tw:flex-wrap tw:items-center tw:gap-2 tw:ml-auto"
            data-test="file-viewer-controls"
        >
            <slot />
        </div>
    </div>
</template>

<script setup>
/**
 * Single chrome row under the drawer header: context labels + optional controls.
 * Kept in-tree (no Teleport) so course/activity and zoom/page controls share one row
 * without losing content when the drawer remounts or updates.
 */
defineProps({
    items: {
        type: Array,
        default: () => [],
    },
});
</script>
